// Fix product image aspect ratio - remove white space by letting images determine their own height
(function() {
  // Update container heights based on image heights - shared function
  const MIN_HEIGHT = 280; // Minimum height in pixels
  
  function updateContainerHeights() {
    const containers = document.querySelectorAll('.product-single__media--image');
    containers.forEach(function(container) {
      if (!container) return;
      
      // Find the image in this container
      const img = container.querySelector('img');
      if (img && img.offsetHeight && img.naturalWidth && img.naturalHeight) {
        // Set container height to match image height, but ensure minimum height
        const calculatedHeight = Math.max(img.offsetHeight, MIN_HEIGHT);
        container.style.setProperty('height', calculatedHeight + 'px', 'important');
        container.style.setProperty('min-height', MIN_HEIGHT + 'px', 'important');
      } else {
        container.style.setProperty('height', 'auto', 'important');
        container.style.setProperty('min-height', MIN_HEIGHT + 'px', 'important');
      }
    });
    
    // Update slide heights
    const slides = document.querySelectorAll('.product-single__media-slide');
    slides.forEach(function(slide) {
      const container = slide.querySelector('.product-single__media--image');
      if (container && container.offsetHeight) {
        const calculatedHeight = Math.max(container.offsetHeight, MIN_HEIGHT);
        slide.style.setProperty('height', calculatedHeight + 'px', 'important');
        slide.style.setProperty('min-height', MIN_HEIGHT + 'px', 'important');
      } else {
        slide.style.setProperty('height', 'auto', 'important');
        slide.style.setProperty('min-height', MIN_HEIGHT + 'px', 'important');
      }
    });
    
    // Update Flickity viewport height
    const viewports = document.querySelectorAll('.product-single__media-slider .flickity-viewport');
    viewports.forEach(function(viewport) {
      const activeSlide = viewport.querySelector('.product-single__media-slide.is-selected, .product-single__media-slide:not(.media--hidden)');
      if (activeSlide && activeSlide.offsetHeight) {
        const calculatedHeight = Math.max(activeSlide.offsetHeight, MIN_HEIGHT);
        viewport.style.setProperty('height', calculatedHeight + 'px', 'important');
        viewport.style.setProperty('min-height', MIN_HEIGHT + 'px', 'important');
      } else {
        // Find tallest slide if no active slide found
        const allSlides = viewport.querySelectorAll('.product-single__media-slide');
        let maxHeight = MIN_HEIGHT;
        allSlides.forEach(function(slide) {
          if (slide.offsetHeight > maxHeight) {
            maxHeight = slide.offsetHeight;
          }
        });
        viewport.style.setProperty('height', maxHeight + 'px', 'important');
        viewport.style.setProperty('min-height', MIN_HEIGHT + 'px', 'important');
      }
    });
  }
  
  function fixImageAspectRatio() {
    // Remove inline padding-top from image height spacers
    const spacers = document.querySelectorAll('.product-single__media--image-height');
    spacers.forEach(function(spacer) {
      if (spacer) {
        spacer.style.cssText = 'padding-top: 0 !important; display: none !important; height: 0 !important; width: 0 !important; visibility: hidden !important;';
      }
    });
    
    // Process images - make them use contain and calculate dynamic height
    const images = document.querySelectorAll('.product-single__media--image img, .product-single__media--image picture img, .product-single__media--image source + img');
    images.forEach(function(img) {
      if (!img) return;
      
      // Set object-fit and width - set min-height immediately
      img.style.setProperty('object-fit', 'contain', 'important');
      img.style.setProperty('width', '100%', 'important');
      img.style.setProperty('max-width', '100%', 'important');
      img.style.setProperty('position', 'relative', 'important');
      img.style.setProperty('min-height', MIN_HEIGHT + 'px', 'important');
      
      // Calculate and set height based on image aspect ratio
      function setImageHeight() {
        if (img.naturalWidth && img.naturalHeight) {
          const containerWidth = img.offsetWidth || img.parentElement.offsetWidth || window.innerWidth;
          const aspectRatio = img.naturalHeight / img.naturalWidth;
          const calculatedHeight = Math.max(containerWidth * aspectRatio, MIN_HEIGHT);
          img.style.setProperty('height', calculatedHeight + 'px', 'important');
          img.style.setProperty('min-height', MIN_HEIGHT + 'px', 'important');
          // Update containers after setting image height
          setTimeout(updateContainerHeights, 10);
        } else {
          img.style.setProperty('height', 'auto', 'important');
          img.style.setProperty('min-height', MIN_HEIGHT + 'px', 'important');
        }
      }
      
      if (img.complete && img.naturalWidth && img.naturalHeight) {
        setImageHeight();
      } else {
        img.onload = function() {
          setImageHeight();
        };
        img.style.setProperty('height', 'auto', 'important');
        img.style.setProperty('min-height', MIN_HEIGHT + 'px', 'important');
      }
    });
    
    // Change figure/lazy-image from absolute to relative
    const figures = document.querySelectorAll('.product-single__media--image figure, .product-single__media--image .lazy-image');
    figures.forEach(function(figure) {
      if (figure) {
        figure.style.cssText = 'position: relative !important; height: auto !important; min-height: ' + MIN_HEIGHT + 'px !important; top: auto !important; left: auto !important; width: 100% !important; margin: 0 !important;';
      }
    });
    
            // Set container styles
            const containers = document.querySelectorAll('.product-single__media--image');
            containers.forEach(function(container) {
              if (container) {
                container.style.setProperty('position', 'relative', 'important');
                container.style.setProperty('width', '100%', 'important');
                container.style.setProperty('display', 'flex', 'important');
                container.style.setProperty('align-items', 'center', 'important');
                container.style.setProperty('justify-content', 'center', 'important');
                container.style.setProperty('min-height', MIN_HEIGHT + 'px', 'important');
              }
            });
            
            // Set min-height on all slides and viewports immediately
            const slides = document.querySelectorAll('.product-single__media-slide');
            slides.forEach(function(slide) {
              if (slide) {
                slide.style.setProperty('min-height', MIN_HEIGHT + 'px', 'important');
              }
            });
            
            const viewports = document.querySelectorAll('.product-single__media-slider .flickity-viewport');
            viewports.forEach(function(viewport) {
              if (viewport) {
                viewport.style.setProperty('min-height', MIN_HEIGHT + 'px', 'important');
              }
            });
    
    // Update heights after a short delay to ensure images are rendered
    setTimeout(updateContainerHeights, 150);
  }
  
  // Run immediately
  setTimeout(fixImageAspectRatio, 0);
  
  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(fixImageAspectRatio, 100);
    });
  } else {
    setTimeout(fixImageAspectRatio, 100);
  }
  
  // Run after images load (for lazy-loaded images)
  if (typeof lazySizes !== 'undefined') {
    document.addEventListener('lazyloaded', function(e) {
      if (e.target.closest('.product-single__media--image')) {
        setTimeout(fixImageAspectRatio, 50);
      }
    });
  }
  
  // Run on window load
  window.addEventListener('load', function() {
    setTimeout(fixImageAspectRatio, 200);
  });
  
  // Handle window resize - recalculate heights dynamically
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(fixImageAspectRatio, 150);
  });
  
  // Watch for Flickity initialization
  const slider = document.querySelector('[data-product-single-media-slider]');
  if (slider) {
    // Use MutationObserver to watch for Flickity class changes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (slider.classList.contains('flickity-enabled')) {
            setTimeout(fixImageAspectRatio, 100);
          }
        }
      });
    });
    
    observer.observe(slider, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    // Also check periodically for Flickity initialization
    let checkCount = 0;
    const checkInterval = setInterval(function() {
      if (slider.classList.contains('flickity-enabled') || checkCount > 20) {
        clearInterval(checkInterval);
        if (slider.classList.contains('flickity-enabled')) {
          setTimeout(fixImageAspectRatio, 100);
        }
      }
      checkCount++;
    }, 100);
    
    // Watch for slide changes in Flickity
    slider.addEventListener('change.flickity', function() {
      setTimeout(fixImageAspectRatio, 50);
    });
  }
  
  // Watch for style changes on viewport (Flickity might change heights)
  const viewportObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        const target = mutation.target;
        if (target.classList && target.classList.contains('flickity-viewport')) {
          setTimeout(fixImageAspectRatio, 50);
        }
      }
    });
  });
  
  // Observe all viewports
  setTimeout(function() {
    const viewports = document.querySelectorAll('.product-single__media-slider .flickity-viewport');
    viewports.forEach(function(viewport) {
      viewportObserver.observe(viewport, {
        attributes: true,
        attributeFilter: ['style']
      });
    });
  }, 500);
  
  // Watch for image load events globally
  document.addEventListener('load', function(e) {
    if (e.target.tagName === 'IMG' && e.target.closest('.product-single__media--image')) {
      setTimeout(fixImageAspectRatio, 50);
    }
  }, true);
})();
